import { render, staticRenderFns } from "./Emailbox.vue?vue&type=template&id=ceef35a2&"
import script from "./Emailbox.vue?vue&type=script&lang=ts&"
export * from "./Emailbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports